import React from 'react';
import { createRoot } from 'react-dom/client';

import 'regenerator-runtime/runtime.js';
import 'core-js/stable';

// Your top level component
import App from './App'; // Export your top level component as JSX (for static rendering)

const container = document.getElementById('root');
const root = createRoot(container!);

// Render!
root.render(<App />);
